import { reskinStyles } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';
import { condensedStyles } from 'core/components/theme/condensed-layout';

const useStyles = (theme) => ({
  container: {
    width: 720,
    ...condensedStyles(theme, { width: '100%', maxWidth: 720 }),
    margin: '0 auto',
    marginTop: theme.spacing(8)
  },
  personLabel: {
    display: 'inline',
    marginRight: theme.spacing(2)
  },
  collapsibleContainer: {
    backgroundColor: theme.colors.card_background_primary_editable,
    padding: theme.spacing(8),
    borderBottomRightRadius: theme.sizes.roundCorners,
    borderBottomLeftRadius: theme.sizes.roundCorners,
    paddingBottom: theme.spacing(7),
    ...reskinStyles(theme, { ...theme.cardStyles.body, borderRadius: 0 })
  },
  cardFooter: {
    backgroundColor: theme.colors.card_background_primary_editable,
    padding: theme.spacing(4, 8),
    borderTop: `1px solid ${theme.colorPalette.beige_50}`,
    borderBottomRightRadius: theme.sizes.roundCorners,
    borderBottomLeftRadius: theme.sizes.roundCorners,
    ...reskinStyles(theme, {
      borderRadius: `0 0 ${theme.sizes.innerCorners}px ${theme.sizes.innerCorners}px`,
      borderTop: `1px solid ${theme.colors.card_divider}`
    })
  }
});

export default makeStyles(useStyles);
